<template>
  <div class="broadcastContainer" :style="styleObj" v-if="winnerList.length">
    <Rolling clipTime="2000">
      <div class="broadcastItem" v-for="item in winnerList" :key="item.id">
        {{ item.content }}
      </div>
    </Rolling>
  </div>
</template>

<script>
import { px2vw } from '@/components/templates/helper';
import Rolling from '@/components/UI/Rolling';

export default {
  components: { Rolling },
  props: {
    actData: {
      type: Object,
      require: true
    },
    backgroundImage: {
      type: String,
      require: true
    },
    fontColor: {
      type: String,
      require: true
    },
    verticalDirection: {
      type: String,
      require: true
    },
    verticalDistance: {
      type: Number,
      require: true
    }
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'component_expo',
      module_name: this.$t ? this.$t('track.base_comp_broadcast') : '跑马灯'
    });
  },
  computed: {
    styleObj() {
      const style = {
        color: this.fontColor,
        background: `center / cover url("${this.backgroundImage}") no-repeat`
      };
      const verticalDirection = this.verticalDirection;
      style[verticalDirection] = px2vw(this.verticalDistance);
      return style;
    },
    winnerList() {
      if (this.actData && this.actData.message) {
        return this.actData.message;
      }
      return [];
    }
  }
};
</script>

<style lang="less" scoped>
.broadcastContainer {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 25px;
}
.broadcastItem {
  width: 510px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
</style>
